// extracted by mini-css-extract-plugin
export default {"achievement":"Achievement_achievement__nJWm6","complete":"Achievement_complete__cDlEp"};